export default __webpack_public_path__ + "static/media/forwardWhite.0f3e9bbc.svg";